import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-upload-req-step-job-boards',
  templateUrl: './upload-req-step-job-boards.component.html'
})
export class UploadReqStepJobBoardsComponent {

  @Input() job: any = {};
  @Input() currentJobStatus;
  @Input() editModeFlag;
  @Input() isTrialPlanActive;
  @Input() jobBoardsResumePullLeft;
  @Input() jobBoardsPullResumePulled;
  @Input() isJobIntegrationEnabledByPlan;
  @Input() isJobBoardServiceUp;
  @Input() showWizardSteps;
  @Input() jobBoardDetailsCopy: any[] = [];
  @Input() activeJobBoardsFilterTabNumber;
  @Input() radiusOptions: any[] = [];
  @Input() recencyOptions: any[] = [];
  @Input() resumePullCounts: any[] = [];
  @Input() resumesToPullPerJobBoardCountCopy;

  @Output() useJobBoardChangeCallback = new EventEmitter<void>();
  @Output() jobBoardSelectionChangeCallback = new EventEmitter<void>();

  onUseJobBoardChange() {
    this.useJobBoardChangeCallback.emit();
  }

  onJobBoardSelectionChange() {
    this.jobBoardSelectionChangeCallback.emit();
  }
}
